import APIMETHODS from "../js/api-methods";
import axios from 'axios'
import { getFormDataFromObject, isObjEmpty, sortArrayByObjProps } from "../js/helper";
let qs = require('qs');

String.prototype.format = function (e) { var t = this; if (arguments.length > 0) if (arguments.length == 1 && typeof e == "object") { for (var n in e) if (e[n] != undefined) { var r = new RegExp("({" + n + "})", "g"); t = t.replace(r, e[n]) } } else for (var i = 0; i < arguments.length; i++) if (arguments[i] != undefined) { var r = new RegExp("({)" + i + "(})", "g"); t = t.replace(r, arguments[i]) } return t };
String.prototype.subStrEx = function (e) { return this.length + 3 > e ? this.substr(0, e) + "..." : this };

function getAjaxRequestOptions({ url, method, data }) {
	const ajaxRequestOptions = {
		"url": url,
		"method": method,
		"timeout": 0,
		"headers": {
			"token": '00000000-0000-0000-0000-000000000000',
			"Content-Type": "application/x-www-form-urlencoded"
		},
		"data": data
	}

	return ajaxRequestOptions
}

function getSSP(url, data) {
	return $.ajax({
		url,
		data,
		type: 'POST',
		async: true,
		cache: false,
	});
}

export default {
	state: () => ({

	}),
	mutations: {

	},
	getters: {

	},
	actions: {
		async GET_MONITORING_UNHANDLE_ALERTS({ commit }, query) {
			try {

				const {
					MajorToken,
					MinorToken,
				} = query

				let url = APIMETHODS.GET_MONITORING_UNHANDLE_ALERTS.format(
					encodeURIComponent(MajorToken),
					encodeURIComponent(MinorToken),
				)

				let response = await fetch(url, {
					method: "GET"
				});

				response = await response.json();
				if (response) {
					return response
				} else {
					response.method = 'GET_MONITORING_UNHANDLE_ALERTS';

					console.log('SET_ERROR', response)
					return false
				}

			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_MONITORING_UNHANDLE_ALERTS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},


		async GET_ALERT_LIST({ commit }, query) {
			try {
				let data = qs.stringify(query)
				const response = await axios.post(APIMETHODS.GET_ALERT_LIST, data);
				if (response.data.MajorCode == '000') {
					return response.data.Data
				} else {
					response.data.method = 'GET_ALERT_LIST';
					commit('SET_ERROR', response.data)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_ALERT_LIST';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},


		async GET_MONITORING_HIS_ALERTS({ commit }, query) {
			try {

				const {
					MajorToken,
					MinorToken,
					beginDate,
					endDate,
					alert,
					imei,
				} = query

				let url = APIMETHODS.GET_MONITORING_HIS_ALERTS.format(
					encodeURIComponent(MajorToken),
					encodeURIComponent(MinorToken),
					encodeURIComponent(beginDate),
					encodeURIComponent(endDate),
					encodeURIComponent(alert),
					encodeURIComponent(imei),
				)

				let response = await fetch(url, {
					method: "GET"
				});

				response = await response.json();
				if (response) {
					return response
				} else {
					response.method = 'GET_MONITORING_HIS_ALERTS';

					console.log('SET_ERROR', response)
					return false
				}

			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_MONITORING_HIS_ALERTS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},

		async HANDLE_ALERT({ commit }, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.HANDLE_ALERT, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return true
				} else {
					response.method = 'HANDLE_ALERT';
					response.query = query;
					response.sendErrorEmail = true;
					response.saveError = true;
					commit('SET_ERROR', response)
					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'HANDLE_ALERT';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async GET_QUERY_PARAMETERS({ commit }, query) {
			try {
				const {
					MajorToken,
				} = query
				let url = APIMETHODS.GET_QUERY_PARAMETERS.format(
					encodeURIComponent(MajorToken),
				)
				let response = await fetch(url, {
					method: "GET"
				});
				response = await response.json();
				if (response) {
					return response
				} else {
					response.method = 'GET_QUERY_PARAMETERS';

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_QUERY_PARAMETERS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},


		async GET_TOP_ALARMS({ commit }, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.GET_TOP_ALARMS, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'GET_TOP_ALARMS';
					response.query = query;
					response.sendErrorEmail = true;
					response.saveError = true;
					commit('SET_ERROR', response)
					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_TOP_ALARMS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async GET_ALARM_STATISTICS({ commit }, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.GET_ALARM_STATISTICS, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'GET_ALARM_STATISTICS';
					response.query = query;
					response.sendErrorEmail = true;
					response.saveError = true;
					commit('SET_ERROR', response)
					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_ALARM_STATISTICS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async GET_REPORT_BY_ALERT({commit}, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.GET_REPORT_BY_ALERT, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'GET_REPORT_BY_ALERT';
					response.query = query;
					response.sendErrorEmail = true;
					response.saveError = true;
					commit('SET_ERROR', response)
					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_REPORT_BY_ALERT';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async GET_ASSETS_LOCATION({commit}, query) {
			try {
				const {
					MajorToken,
					MinorToken,
				} = query

				let url = APIMETHODS.GET_ASSETS_LOCATION.format(
					encodeURIComponent(MajorToken),
					encodeURIComponent(MinorToken),
				)
				 let data = qs.stringify(query.codes)
 
				let response = await fetch(url, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'GET_ASSETS_LOCATION';
					response.query = query;
					response.sendErrorEmail = true;
					response.saveError = true;
					commit('SET_ERROR', response)
					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_ASSETS_LOCATION';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		

	}
}